import { InfoDropdownV2 } from '@/components/custom/erp';

const InfoDropdown = ({ uuid, ma_ct, className }: { uuid: string; ma_ct: string; className?: string }) => (
  <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} className={className} />
);

export default InfoDropdown;
